import React from 'react';
import {getElementAttributes} from 'helpers';
import css from './grid.module.scss';

export function Grid({ columns, ...props }) {
  return (
    <div {...getElementAttributes(props)} className={css('grid', props, columns && 'columns-'+columns)}>
      { props.children }
    </div>
  );
}

Grid.Width100 = props => (
  <div {...getElementAttributes(props)} className={css('width-100', props)}>
    { props.children }
  </div>
);
